import { useState } from "react";
import { Plus, Trash2, ArrowUp, ArrowDown, Eye, EyeOff } from "lucide-react";
import { Input, ImageInput, Toggle } from "./fields";
import { FicheOverlay, ItemCard, CardGrid } from "./Fiche";

// Dedicated partners editor: logo upload, per-partner on/off, ordering, whole-section on/off.
export const AdminPartners = ({ value = {}, onChange }) => {
  const [open, setOpen] = useState(null);
  const v = value || {};
  const items = Array.isArray(v.items) ? v.items : [];
  const set = (k, val) => onChange({ ...v, [k]: val });
  const setItem = (i, up) => set("items", items.map((it, x) => (x === i ? { ...it, ...up } : it)));
  const add = () => { set("items", [...items, { name: "", logo: "", url: "", enabled: true }]); setOpen(items.length); };
  const remove = (i) => set("items", items.filter((_, x) => x !== i));
  const move = (i, d) => { const j = i + d; if (j < 0 || j >= items.length) return; const c = [...items]; [c[i], c[j]] = [c[j], c[i]]; set("items", c); };

  return (
    <div className="space-y-5" data-testid="admin-partners">
      <div className="rounded-lg border border-white/10 bg-[#0a0a0a] p-4 space-y-3">
        <Toggle label="Afficher la section « Ils nous soutiennent »" hint="Affiche ou masque toute la section partenaires sur le site." checked={v.enabled !== false} onChange={(val) => set("enabled", val)} />
        <Input label="Sur-titre de la section" value={v.eyebrow} onChange={(val) => set("eyebrow", val)} placeholder="Ils nous soutiennent" />
      </div>

      <div className="flex items-center justify-between">
        <span className="text-[11px] tracking-[0.25em] uppercase text-electric">Partenaires ({items.length})</span>
        <button type="button" onClick={add} data-testid="partner-add-btn" className="inline-flex items-center gap-1.5 text-xs text-electric hover:text-white border border-electric/30 rounded-full px-3 py-1.5"><Plus size={13} /> Ajouter un partenaire</button>
      </div>

      {open !== null && items[open] ? (
        <FicheOverlay testid="partner-fiche" title={items[open].name || `Partenaire #${open + 1}`} subtitle="Partenaire" onClose={() => setOpen(null)}>
          <Toggle label="Affiché sur le site" checked={items[open].enabled !== false} onChange={(val) => setItem(open, { enabled: val })} />
          <ImageInput label="Logo / image" value={items[open].logo} onChange={(val) => setItem(open, { logo: val })} />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Input label="Nom" value={items[open].name} onChange={(val) => setItem(open, { name: val })} />
            <Input label="Site / lien (optionnel)" value={items[open].url} onChange={(val) => setItem(open, { url: val })} placeholder="https://…" />
          </div>
        </FicheOverlay>
      ) : (
        <>
          {items.length === 0 && <p className="text-xs text-secondary2/70">Aucun partenaire pour l'instant.</p>}
          <CardGrid testid="partners-cards">
            {items.map((it, i) => (
              <ItemCard key={i} testid={`partner-item-${i}`}
                image={it.logo} title={it.name || `Partenaire #${i + 1}`} subtitle={it.url}
                dimmed={it.enabled === false}
                badges={[{ label: it.enabled !== false ? "Affiché" : "Masqué", tone: it.enabled !== false ? "text-electric border-electric/40 bg-black/60" : "text-white/50 border-white/15 bg-black/60" }]}
                onOpen={() => setOpen(i)}
                actions={
                  <>
                    <button type="button" onClick={() => setItem(i, { enabled: it.enabled === false })} title={it.enabled !== false ? "Masquer" : "Afficher"}
                      className={`p-2 rounded border border-white/10 ${it.enabled !== false ? "text-electric" : "text-white/30"} hover:border-electric`}>{it.enabled !== false ? <Eye size={14} /> : <EyeOff size={14} />}</button>
                    <button type="button" onClick={() => move(i, -1)} title="Monter" className="p-2 rounded border border-white/10 text-white/40 hover:text-electric"><ArrowUp size={14} /></button>
                    <button type="button" onClick={() => move(i, 1)} title="Descendre" className="p-2 rounded border border-white/10 text-white/40 hover:text-electric"><ArrowDown size={14} /></button>
                    <button type="button" onClick={() => remove(i)} data-testid={`partner-remove-${i}`} title="Supprimer" className="p-2 rounded border border-white/10 text-red-400/70 hover:text-red-400 hover:border-red-400/40"><Trash2 size={14} /></button>
                  </>
                } />
            ))}
          </CardGrid>
        </>
      )}
    </div>
  );
};
